
import layoutMixin from "@/mixins/layout"

export default {
  mixins: [layoutMixin],
}
